// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".page .logo[data-v-f069e63c] {\n  width: 120px;\n}\n.page .btn-group[data-v-f069e63c] {\n  color: #C0C4CC;\n  font-size: 12px;\n  line-height: 12px;\n  margin-top: 0px;\n  margin-bottom: 20px;\n}\n.page .btn-group .btn-group__btn[data-v-f069e63c] {\n  color: #909399;\n}\n.page .btn-group .btn-group__btn[data-v-f069e63c]:hover {\n  color: #303133;\n}\n.page .btn-group .btn-group__btn.btn-group__btn--link[data-v-f069e63c] {\n  color: #409EFF;\n}", ""]);
// Exports
module.exports = exports;
